import { IQuota, IQuotaCompletes } from "./IQuota";
import { IQuotaTable } from "./IQuotaTable";
import { ITarget } from "./ITarget";
import { IQuestion } from "./IQuestion";

export interface INatRepQuotasRequest {
  countryCode: string;
  countryCultures: Array<string>;
  quotaTables: Array<IQuotaTable>;
  target: ITarget[];
}

export class NatRepQuotasRequest implements INatRepQuotasRequest {
	countryCode: string;
	countryCultures: Array<string>;
	quotaTables: Array<IQuotaTable>;
	target: ITarget[];

	constructor() {
		this.countryCode = null;
		this.countryCultures = [];
		this.quotaTables = [];
		this.target = [];
	}
}



// WEBPACK FOOTER //
// ./src/app/models/INatRepQuotasRequest.ts